export default "__VITE_ASSET__DjGd0z2K__"